var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"app_bar_text_color--text",attrs:{"items":_vm.breadcrumbs,"divider":"/"}})
}
var staticRenderFns = []

export { render, staticRenderFns }